import { render, staticRenderFns } from "./RegistrationTypeSelector.vue?vue&type=template&id=978f5580&"
import script from "./RegistrationTypeSelector.vue?vue&type=script&lang=js&"
export * from "./RegistrationTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports